var _excluded = ["label", "variant", "size", "newTab", "shouldSupportEllipsis", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef, useRef } from 'react';
import { mergeRefs, useHasOverflowX } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Tooltip } from '../../dataDisplay';
import { Box } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var Link = /*#__PURE__*/forwardRef((_ref, propRef) => {
  var {
    label,
    variant,
    size,
    newTab,
    shouldSupportEllipsis,
    color
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('Link', {
    variant,
    size,
    shouldSupportEllipsis,
    color
  });
  var linkRef = useRef(null);
  var ref = mergeRefs([linkRef, propRef]);
  var hasOverflow = useHasOverflowX({
    ref: linkRef
  });
  var showTooltip = !!shouldSupportEllipsis && hasOverflow;
  return /*#__PURE__*/_jsx(Tooltip, {
    label: label,
    isEnabled: showTooltip,
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      __css: styles,
      as: "a",
      "data-component": "Link",
      role: "link",
      target: newTab ? '_blank' : '_self'
    }, props), {}, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ref: ref,
      children: label
    }))
  });
});
Link.displayName = 'Link';
//# sourceMappingURL=Link.js.map